import { addDoc, collection } from "firebase/firestore";
import { getDb } from "@/services/firebase/config";
import type { TutorialForm } from "@/types/tutorial/Tutorial";

const COLLECTION_NAME = "tutoriais";

class CreateTutorial {
  execute = async (tutorial: TutorialForm): Promise<string> => {
    const db = getDb();
    const col = collection(db, COLLECTION_NAME);
    const docRef = await addDoc(col, {
      title: tutorial.title,
      link: tutorial.link,
      category: tutorial.category,
    });
    return docRef.id;
  };
}

export { CreateTutorial };
